const $inject = [
  "$scope",
  "UserService",
  "data",
];

class UserDataController {
  constructor(
    $scope,
    UserService,
    data
  ) {
    this.$scope = $scope;
    this.UserService = UserService;
    this.data = data;
    this.backup();
    this.name_order = true;

    this.sort = {
      id: null,
      name: null,
      roles: null,
    };

    $scope.Math = Math;
    $scope.search = {
      id: "",
      name: "",
      roles: [],
    };
    this.set_view($scope, this.data.users, [10, 30, 100, "All"]);

    $scope.$watch("search", () => this.set_filtered_items(), true);

    this.sort_data();
  }

  set_view($scope, items, page_sizes = [10, 20, 50, 100, "All"]) {
    $scope.view = {
      page_sizes,
      per_page: null,

      current_page: 1,
      total_pages: null,

      start_item: 0,
      previous_item: 0,
      previous_total: items.length,
    };
    $scope.view.per_page = $scope.view.page_sizes[0];
    $scope.view.total_pages = Math.ceil(items.length / $scope.view.per_page);
  }

  save_roles() {
    this.saving = true;
    let self = this;
    let users = this.sorted.users
      .filter(user => !self.same_contents(user.accountRoles, this.original_data.users[user.id].accountRoles, role => role.name))
      .map(user => ({id: user.id, accountRoles: user.accountRoles.map(role => role.id), change_reason: user.change_reason === undefined? null: user.change_reason}));

    function handleSuccess(response) {
      let users = {};
      for (let user of Object.values(response.data.data.users)) {
        users[user.id] = user;
      }
      for (let i in self.data.users) {
        let user = self.data.users[i];
        if (users[user.id]) {
          self.data.users[i] = users[user.id];
        }
      }

      self.backup();
      self.sort_data();
      self.saving = false;
    }

    //noinspection JSUnusedLocalSymbols
    function handleError(response) {
      console.log("Error!");
      self.saving = false;
    }

    this.UserService.save_user_roles(users, handleSuccess, handleError);
  }

  backup() {
    this.original_data = angular.copy(this.data);
    let users = {};
    for (let user of this.original_data.users) {
      users[user.id] = user;
    }
    this.original_data.users = users;
    this.$scope.data = angular.copy(this.original_data);
  }

  same_contents(arr1, arr2, transform = item => item) {
    return JSON.stringify(arr1.map(transform).sort()) === JSON.stringify(arr2.map(transform).sort());
  }

  //noinspection JSUnusedGlobalSymbols
  get_role_tag_class(id, $tag, $index, $selected) {
    return !this.original_data.users[id].accountRoles.filter(role => role.name === $tag.name).length && !$selected;
  }

  //noinspection JSUnusedGlobalSymbols
  get_role_tags(query) {
    let self = this;
    //noinspection JSUnusedLocalSymbols
    return new Promise(function (resolve, reject) {
      resolve(self.data.roles.filter(role => role.description.toLowerCase().includes(query.toLowerCase())));
    });
  }

  sort_by(column) {
    switch (this.sort[column]) {
      case 1:
        this.sort[column] = -1;
        break;
      case -1:
        this.sort[column] = null;
        if (column === "name") {
          this.name_order = !this.name_order;
        }
        break;
      default:
        this.sort[column] = 1;
    }

    for (let key in this.sort) {
      if (key !== column) {
        this.sort[key] = null;
      }
    }

    this.sort_data();
  }

  sort_data() {
    let transform;
    let order;

    switch (true) {
      case this.sort.id !== null:
        transform = item => item.id;
        order = this.sort.id;
        break;
      case this.sort.name !== null:
        transform = item => this.full_name(item);
        order = this.sort.name;
        break;
      case this.sort.roles !== null:
        let sort_order = (arr, reverse = true) => reverse? arr.reverse(): arr;
        transform = item => sort_order(item.accountRoles.map(role => role.description).sort(), order < 0);
        order = this.sort.roles;
        break;
      default:
        transform = item => item;
        order = 0;
    }

    this.sorted = angular.copy(this.data);
    this.sorted.users.sort((a, b) => transform(a) > transform(b)? order: transform(a) < transform(b)? -order: 0);

    this.set_filtered_items();
  }

  sort_indicator(field) {
    switch (this.sort[field]) {
      case 1:
        return "fa-sort-asc";
      case -1:
        return "fa-sort-desc";
    }
    return "";
  }

  set_filtered_items() {
    this.$scope.data.users = this.sorted.users.filter(this.filter_by(this.$scope.search));
    this.set_total_pages();
  }

  filter_by(search) {
    let self = this;
    return function (value) {
      return self.string_search(search.id, value.id) &&
        self.string_search(search.name, self.full_name(value)) &&
        self.array_search(search.roles, value.accountRoles, role => role.id);
    };
  }

  full_name(user) {
    let names = [user.firstName, user.lastName].filter(name => name !== null);
    return this.name_order? names.join(" "): names.reverse().join(", ");
  }

  string_search(needle, haystack) {
    return String(haystack).replace(/\s+/, " ").toLowerCase().includes(String(needle).replace(/\s+/, " ").toLowerCase());
  }

  array_search(needles, haystack, transform = item => item) {
    return needles.every(needle => haystack.some(straw => transform(needle) === transform(straw)));
  }

  set_per_page(size) {
    this.$scope.view.per_page = size;
    this.set_total_pages();
  }

  set_total_pages() {
    this.$scope.view.total_pages = Math.ceil(this.$scope.data.users.length / this.$scope.view.per_page);
    this.set_current_page();
  }

  set_page(page) {
    this.$scope.view.previous_item = (page - 1) * this.$scope.view.per_page;
    this.$scope.view.previous_total = this.$scope.data.users.length;
    this.set_current_page();
  }

  set_current_page() {
    this.$scope.view.current_page = Math.floor(this.$scope.view.previous_item * this.$scope.data.users.length / this.$scope.view.previous_total / this.$scope.view.per_page) + 1;
    this.$scope.view.start_item = (this.$scope.view.current_page - 1) * this.$scope.view.per_page;
  }

  valid() {
    return true;
  }

  invalid() {
    return false;
  }
}

UserDataController.$inject = $inject;
export default UserDataController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/admin/controllers/user-data.controller.js
 **/